import Link from "@mui/material/Link";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Link key={component.id} />;
}

export default Component;
